import * as React from 'react'
import type { SVGProps } from 'react'
function SvgSozialleistungenAlterGrundsicherung235198422951(
  props: SVGProps<SVGSVGElement>,
) {
  return (
    <svg
      viewBox="0 0 202.4 218.2"
      x="0px"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      xmlSpace="preserve"
      y="0px"
      {...props}
    >
      <g>
        <path d="M45.3,196.9C20.3,181.3,6,155.5,6,126V26c32.2-0.4,62.4-7.7,80.9-19.4c18.5,11.8,48.7,19,80.9,19.4v85.6c0,1.7,1.3,3,3,3 s3-1.3,3-3V23c0-1.7-1.3-3-3-3c-33.4,0-64.1-7.3-82.2-19.5c-1-0.7-2.3-0.7-3.4,0C67.1,12.7,36.4,20,3,20c-1.7,0-3,1.3-3,3V126 c0,31.6,15.4,59.3,42.2,76c0.5,0.3,1,0.5,1.6,0.5h0c1,0,2-0.5,2.5-1.4c0.4-0.7,0.6-1.5,0.4-2.3C46.5,198,46,197.3,45.3,196.9z" />
        <path d="M23,53c0-1.7-1.3-3-3-3s-3,1.3-3,3v23.5c0,1.7,1.3,3,3,3s3-1.3,3-3V53z" />
        <path d="M20,93.9c-1.7,0-3,1.3-3,3v18.9c0,1.7,1.3,3,3,3s3-1.3,3-3V96.9C23,95.2,21.6,93.9,20,93.9z" />
        <path d="M199.4,147.3H199v-18.7c0-1.7-1.3-3-3-3h-64.1c-1.7,0-3,1.3-3,3v21.7c0,1.7,1.3,3,3,3h3.3c0,0,0.1,0,0.1,0h61.1v15.7h-53.8 c-1.7,0-3,1.3-3,3c0,0,0,0,0,0s0,0,0,0c0,1.7,1.3,3,3,3h42v15.7h-46.2c-1.7,0-3,1.3-3,3s1.3,3,3,3h46.2v15.7H130c-1.7,0-3,1.3-3,3 s1.3,3,3,3h57.5c1.7,0,3-1.3,3-3v-21.7v-18.7h8.9c1.7,0,3-1.3,3-3v-21.7C202.4,148.6,201,147.3,199.4,147.3z M193,147.2h-58.1 v-15.7H193V147.2z" />
        <path d="M91.8,143.1c-20.7,0-37.5,16.8-37.5,37.6s16.8,37.5,37.5,37.5s37.5-16.8,37.5-37.5S112.5,143.1,91.8,143.1z M91.8,212.2 c-17.4,0-31.5-14.2-31.5-31.5c0-17.4,14.2-31.6,31.5-31.6s31.5,14.2,31.5,31.6C123.3,198.1,109.1,212.2,91.8,212.2z" />
        <path d="M91.8,195.2c-8,0-14.6-6.5-14.6-14.6c0-1.7-1.3-3-3-3s-3,1.3-3,3c0,11.3,9.2,20.6,20.6,20.6c1.7,0,3-1.3,3-3 S93.4,195.2,91.8,195.2z" />
      </g>
    </svg>
  )
}
export default SvgSozialleistungenAlterGrundsicherung235198422951
